export default __webpack_public_path__ + "assets/Compare14.png";